
import { Apps } from '@/dtos'
import { useApp } from '@/hooks/useApp'
import { Flex } from '@chakra-ui/react'
import { Hint } from 'BrokerTsLib/src/components'
import { FormSection } from '../../../../forms/FormSection'
import { InsureeForm } from '../forms/InsureeForm'

export const Insuree = ({ number = 2 }: { number?: number }) => {
  const { app } = useApp()

  return (
    <FormSection
      number={number}
      sectionTitle={(
        <Flex>
          Pojistník

          {
            app == Apps.publicPoleas &&
            <Hint
              type={'info'}
              maxW={500}
              hasArrow
              placement='top'
            >
              Osoba, která uzavírá pojistnou smlouvu. Má právo disponovat s pojistnou smlouvou a povinnost platit pojistné.
            </Hint>
          }
        </Flex>
      )}
    >
      <InsureeForm />

    </FormSection>
  )
}
